import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import useUpdateCoMaedcv from '../Hooks/useUpdateCoMaedcv';

const ModalModificarCoMaedcv = ({ isOpen, toggle, onSave, selectedRecord }) => {
    const [formData, setFormData] = useState({});
    const { updateCoMaedcv, loading } = useUpdateCoMaedcv();

    const [claemp, tipfol, numfol] = selectedRecord.split('-');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async () => {
        const result = await updateCoMaedcv(parseInt(claemp), tipfol, parseInt(numfol), formData);
        if (result.success) {
            alert('Registro actualizado exitosamente');
            onSave();
            toggle();
        } else {
            alert('Error al actualizar: ' + result.error);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Registro CO_MAEDCV</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="TIPDOC">Tipo Documento</Label>
                        <Input type="text" name="TIPDOC" id="TIPDOC" value={formData.TIPDOC || ''} onChange={handleChange} />
                    </FormGroup>
                    {/* Add more fields here */}
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSubmit} disabled={loading}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarCoMaedcv;